import { useEffect, useState } from 'react';

/**
 * useDebounce
 *
 * @param value - value to be debounced
 * @param delay - debounce delay in milliseconds
 * @returns debounced value
 */
function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

export default useDebounce;
